import * as React from 'react';
import { Link as GLink } from 'gatsby';
import { AnchorLink } from 'gatsby-plugin-anchor-links';

interface Props {
    usingMouse?: boolean;
    id?: string;
    role?: string;
    title?: string;
    ariaLabel?: string;
    rel?: string;
    onBlur?: () => void;
    onFocus?: () => void;
    onKeyPress?: any;
    children?: any;
    forceRefresh?: boolean;
    newTab?: boolean;
    style?: {
        font?: string;
        className?: string;
    };
}

const Link = (
    props:
        | (Props & {
              link: string;
              onClick?: () => void;
          })
        | (Props & {
              link?: string;
              onClick: () => void;
          })
) => {
    const {
        usingMouse,
        link,
        style = {
            font: 'body1',
            className: ''
        },
        id = '',
        role = 'none',
        onClick = () => {
            /* DO NOTHING */
        },
        onBlur,
        onFocus,
        onKeyPress,
        children,
        forceRefresh = false,
        title = '',
        ariaLabel = '',
        rel = '',
        newTab = true
    } = props;

    if (forceRefresh || (link && link[0] !== '/') || !link) {
        return (
            // eslint-disable-next-line react/jsx-no-target-blank
            <a
                tabIndex={0}
                rel={newTab ? 'noopener noreferrer' : rel}
                target={newTab ? '_blank' : ''}
                href={link}
                role={role}
                id={id}
                title={title}
                aria-label={ariaLabel}
                onClick={onClick}
                onKeyPress={
                    onKeyPress
                        ? onKeyPress
                        : (event: React.KeyboardEvent<HTMLAnchorElement>) => {
                              if (event.key === 'Enter') {
                                  onClick();
                              }
                          }
                }
                download={link?.includes('.pdf') ? true : false}
                onBlur={onBlur}
                onFocus={onFocus}
                className={
                    usingMouse
                        ? `using-mouse ${style.font} ${style.className}`
                        : `${style.font} ${style.className}`
                }>
                {children}
            </a>
        );
    } else if (link && link.includes('#')) {
        return (
            <AnchorLink
                to={link}
                title={title}
                aria-label={ariaLabel}
                className={
                    usingMouse
                        ? `using-mouse ${style.font} ${style.className}`
                        : `${style.font} ${style.className}`
                }>
                {children}
            </AnchorLink>
        );
    } else {
        return (
            <GLink
                rel={rel}
                to={link}
                role={role}
                id={id}
                title={title}
                aria-label={ariaLabel}
                onClick={onClick}
                onKeyPress={
                    onKeyPress
                        ? onKeyPress
                        : (event: React.KeyboardEvent<HTMLAnchorElement>) => {
                              if (event.key === 'Enter') {
                                  onClick();
                              }
                          }
                }
                download={link?.includes('.pdf') ? true : false}
                onBlur={onBlur}
                onFocus={onFocus}
                className={
                    usingMouse
                        ? `using-mouse ${style.font} ${style.className}`
                        : `${style.font} ${style.className}`
                }>
                {children}
            </GLink>
        );
    }
};

export default Link;
